import React from 'react';
import PropTypes from 'prop-types';
import { keys, camelCase } from 'lodash';
import {
  Row,
  Col
} from 'react-bootstrap';

const InfoViewComponent = ({ title, items, showWide }) => {
  return (
    <div>
      <fieldset>
        <legend>
          {title}
        </legend>
      </fieldset>
      <div>
        {
          items ?
            keys(items).map((key, i) => {
              return items[key] ?
                (
                  <div key={i}>
                    <Row>
                      <Col md={showWide ? 9 : 6}>{camelCase(key)}</Col>
                      <Col md={showWide ? 3 : 6}>{items[key]} </Col>
                    </Row>
                  </div>
                ) : null;
            }) : null
        }
      </div>
    </div>
  );
};

InfoViewComponent.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.object,
  showWide: PropTypes.bool
};

export default InfoViewComponent;


// WEBPACK FOOTER //
// src/Components/InfoViewComponent.jsx